module.exports = __webpack_public_path__ + "static/media/avc_vidoe_icon.d145f8d9.svg";